<template>
	<div class="flex flex-col py-0 lg:pt-10 xl:pt-0">
		<div class="lg:hidden">
			<div class="text-center">
				<div class="px-6">
					<img
							v-if="heroLogo.length"
							:src="heroLogo[0].url"
							class="block my-20 mx-auto" />
					<h1 class="mb-10 md:px-14" v-html="secondaryHeading"></h1>
					<h2 class="leading-tight text-hamlet-gold px-4 md:px-14" v-html="mainHeading"></h2>
					<div v-if="cta" class="w-full flex justify-center">
						<a :class="['cta mt-10',ctaTracking].join(' ')" :href="cta.url">
							<span v-html="cta.text"/>
							<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0)">
									<path d="M2.34501 5.61755L5.34058e-05 0L10.46 5.61755L5.34058e-05 11.25L2.34501 5.61755Z" fill="#F4D995"/>
								</g>
								<defs>
									<clipPath id="clip0">
										<rect width="11.25" height="10.4599" fill="white" transform="translate(10.46) rotate(90)"/>
									</clipPath>
								</defs>
							</svg>
						</a>
					</div>
				</div>
				<div class="mt-16">
					<div class="bg-no-repeat bg-center mx-auto"
							 :style="[mobileIndex >= 0 && mobile.length ? { backgroundImage:`url(${mobile[mobileIndex].url})`}: {}]"
					>
						<img
								v-if="mobileImages.length"
								:src="mobileImages[0].url"
								:class="mobileIndex >= 0? 'invisible':''"
								class="block" />
					</div>
					<div class="table mx-auto mt-8 mb-14">
						<span class="font-bold border-b table border-black h1 mb-4 leading-none" v-html="bottomMessage" />
						<svg width="10" height="10" viewBox="0 0 10 10" fill="none" class="mx-auto table">
							<g clip-path="url(#clip0)">
								<path d="M5.00662 2.18544L10 7.62939e-06L5.00662 9.74835L8.52227e-07 6.75517e-06L5.00662 2.18544Z" fill="black"/>
							</g>
							<defs>
								<clipPath id="clip0">
									<rect width="10" height="9.74834" fill="white" transform="translate(10 9.74835) rotate(-180)"/>
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div class="hidden lg:flex flex-wrap hero">
			<div class="flex w-full">
				<div class="w-1/2">
					<div class="flex items-end h-full">
						<h1 class="mb-24 text-hamlet-gold" v-html="secondaryHeading"></h1>
					</div>
				</div>
				<div class="w-1/2">
					<div class="bg-no-repeat bg-left-bottom"
							 :style="[centreIndex >= 0 && centre.length ? { backgroundImage:`url(${centre[centreIndex].url})`}: {}]"
					>
						<img
								v-if="centreImages.length"
								:src="centreImages[0].url"
								:class="centreIndex >= 0? 'invisible':''"
								class="block" />
					</div>
				</div>
			</div>
			<div class="w-full flex justify-center items-center -mb-12 -mt-24 z-30">
				<div class="">
					<img
							v-if="heroLogo.length"
							:src="heroLogo[0].url"
							class="block" />
				</div>
			</div>
			<div class="flex w-full">
				<div
						class="w-1/2 bg-no-repeat bg-left-bottom bg-left-top"
						:style="[leftIndex >= 0 && left.length ? { backgroundImage:`url(${left[leftIndex].url})`}: {}]">
					<img
							v-if="leftImages.length"
							:src="leftImages[0].url"
							:class="leftIndex >= 0? 'invisible':''"
							class="block" />
				</div>
				<div class="w-1/2 flex flex-col pb-20">
					<div class="relative">
						<h2 class="absolute leading-tight text-hamlet-gold bottom-0 left-0 z-30 w-10/12" v-html="mainHeading"></h2>
						<div class="absolute right-0 bottom-0 bg-no-repeat bg-right-bottom"
								 :style="[rightIndex >= 0 && right.length ? { backgroundImage:`url(${right[rightIndex].url})`}: {}]">
							<img
									v-if="rightImages.length"
									:src="rightImages[0].url"
									:class="rightIndex >= 0? 'invisible':''"
									class="block" />
						</div>
						<img
								v-if="rightImages.length"
								:src="rightImages[0].url"
								:class="rightIndex >= 0? 'invisible':''"
								class="block mt-8 float-right" />
					</div>
					<div class="mt-16">
						<div class="table ">
							<span class="font-bold border-b table border-black h1 mb-4 leading-none" v-html="bottomMessage" />
							<svg width="10" height="10" viewBox="0 0 10 10" fill="none" class="mx-auto table animate-bounce">
								<g clip-path="url(#clip0)">
									<path d="M5.00662 2.18544L10 7.62939e-06L5.00662 9.74835L8.52227e-07 6.75517e-06L5.00662 2.18544Z" fill="black"/>
								</g>
								<defs>
									<clipPath id="clip0">
										<rect width="10" height="9.74834" fill="white" transform="translate(10 9.74835) rotate(-180)"/>
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "hero",
	props: {
		mainHeading: {
			type: String,
			default: ""
		},
		cta: {
			type: [Boolean, Object],
			default: false
		},
		secondaryHeading: {
			type: String,
			default: ""
		},
		bottomMessage: {
			type: String,
			default: ""
		},
		ctaTracking: {
			type: String,
			default: ""
		},
		heroLogo: {
			type: Array,
			default: () => []
		},
		mobileImages: {
			type: Array,
			default: () => []
		},
		leftImages: {
			type: Array,
			default: () => []
		},
		rightImages: {
			type: Array,
			default: () => []
		},
		centreImages: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			leftIndex: 0,
			centreIndex: 0,
			rightIndex: 0,
			left: [],
			centre: [],
			right: [],
			mobile: [],
			mainIndex: 0,
			mobileIndex: 0
		};
	},
	methods: {
		getNextIndex(set){
			const length = this[set].length;
			const index = this[`${set}Index`];
			if(index + 1 < length){
				this[`${set}Index`] = index + 1;
			}else {
				this[`${set}Index`] = 0;
			}
		},
		loopImages(){
			const indexes = ['left', 'centre', 'right'];
			setInterval(() => {
				if(this.mainIndex === 3){
					this.mainIndex = 0;
				}
				let set = indexes[this.mainIndex]
				this.getNextIndex(set);
				this.mainIndex = this.mainIndex + 1;
			}, 2500)

			// Mobile
			setInterval(() => {
				this.getNextIndex('mobile');
			}, 2500)
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.left = this.leftImages;
			this.centre = this.centreImages;
			this.right = this.rightImages;
			this.mobile = this.mobileImages;
			this.loopImages()
		});
	}
}
</script>

<style scoped>

</style>
